<template>
  <el-dialog :visible.sync="visible" title="学生信息更新" :close-on-click-modal="false" :close-on-press-escape="false"
             :destroy-on-close="true">
    <el-upload
        :action="url"
        drag
        :multiple="false"
        :show-file-list="false"
        :before-upload="beforeUploadHandle"
        :on-success="successHandle"
        class="text-center">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text"
           v-html="$t('upload.text')"></div>
      <div class="el-upload__tip"
           slot="tip">{{ $t('upload.tip', {'format': 'Excel'}) }}
      </div>
      <div class="el-upload__tip"
           slot="tip"><a :href="tempUrl">点击下载学生信息更新模板</a></div>
    </el-upload>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" class="custom-form" style="width:50%;margin:0px auto;" >
		<el-row>
		<el-col :span="8"><div class="grid-content bg-purple"></div></el-col>
		<el-col :span="16"> 
		<el-form-item label="更新方式" prop="updateType"   style="width: 100%">
        <el-radio-group v-model="dataForm.updateType" @change="changeUpdateTypeHandle()">
          <el-radio label="1">学号</el-radio>
          <el-radio label="2">身份证号</el-radio>
        </el-radio-group>
      </el-form-item></el-col>
		</el-row>


	


      <el-form-item prop="schoolId" class="custom-form-item" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable @change="changeSchoolHandle()">
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
  name: 'student-update-import',
  data () {
    return {
      visible: false,
      url: '',
      tempUrl: '',
      loading: {},
      schoolVisible: false,
      schoolList: [],
      dataForm: {
		  updateType:'1',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        // 初始化表单
        this.$refs.dataForm.resetFields()
        this.resetValue()
        const params = qs.stringify({
          token: Cookies.get('token'),
          schoolId: this.dataForm.schoolId,
		  updateType: this.dataForm.updateType
        })
        // 初始化链接
        this.tempUrl = `${window.SITE_CONFIG.apiURL}/student/student/repImportStudentUpdateTpl?${params}`
        this.url = `${window.SITE_CONFIG.apiURL}/student/student/importStudentUpdate?${params}`
        this.fileList = []
        this.num = 0
      })
    },
    changeSchoolHandle () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        schoolId: this.dataForm.schoolId,
				  updateType: this.dataForm.updateType
      })
      this.url = `${window.SITE_CONFIG.apiURL}/student/student/importStudentUpdate?${params}`
    },
	    changeUpdateTypeHandle () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        schoolId: this.dataForm.schoolId,
		 updateType: this.dataForm.updateType
      })
      this.url = `${window.SITE_CONFIG.apiURL}/student/student/importStudentUpdate?${params}`
    },
	
    beforeUploadHandle (file) {
      // 文件格式校验
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel' &&
          file.name.indexOf('xls') === -1 && file.name.indexOf('xlsx') === -1) {
        this.$message.error(this.$t('upload.tip', { format: 'Excel' }))
        return false
      }
      // 必填项校验
      if (this.schoolVisible && !this.dataForm.schoolId) {
        return this.$refs.dataForm.validate((validate) => {
          if (!validate) {
            return false
          }
        })
      }
      this.loading = this.$loading({
        lock: true,
        text: '处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    successHandle (res, file, fileList) {
      this.loading.close()
      if (res.code !== 0) {
        if (res.code === 10050) {
          this.schoolVisible = true
          this.getSchoolList()
        }
        return this.$message.error(res.msg)
      }
      this.$message({
        message: this.$t('prompt.success'),
        type: 'success',
        duration: 500,
        onClose: () => {
          this.visible = false
          this.$emit('refreshDataList')
        }
      })
    },
    resetValue () {
      this.dataForm.schoolId = ''
	  this.dataForm.updateType = '1'
      this.schoolVisible = false
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.custom-form {
  margin-top: 20px;
  text-align: center;
}

.custom-form-item >>> .el-form-item__error {
  position: relative !important;
}
</style>
